// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */
 import logo from 'assets/images/one_pay_logo_white.svg';

// ==============================|| LOGO SVG ||============================== //

const LogoMobile = () => {
    const theme = useTheme();

    return (
        <img src={logo} alt="fastek" width="150" />
    );
};

export default LogoMobile;
